export const addSearchParamToUrl = (name: string, value: string, location = window.location): string => {
  const { routerPath, searchString } = getHashParams(location);
  const search = new URLSearchParams(searchString);
  if (search.has(name)) {
    search.delete(name);
  }
  search.append(name, value);
  const hash = `#${routerPath}?${search}`;
  const link = location.origin + location.pathname + location.search + hash;
  return link;
};

export const getHashParams = (location: Location) => {
  const [routerPath, searchString] = location.hash.substring(1).split('?');
  return { routerPath, searchString };
};
